<script setup>
const route = useRoute()
if (route.path !== '/zoom-map/') {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
useCustomMeta('zoom-map', '')
const breadCrumbList = [{ text: 'ライブカメラ', link: '../' }, { text: 'マップ' }]
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
    >
      <LivecamMapPlot />
      <template #main-bottom>
        <LivecamAreaList />
        <LivecamFeature target-key="focus_livecam" />
        <HorizontalStackAd
          v-if="!isWebViewFlag"
          left-ad-id="ads-btf2-left-pc"
          right-ad-id="ads-btf2-right-pc"
        />
        <div
          id="ads-btf1-sp"
          class="ads-btf1-sp"
        />
        <TopicList />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
